<template>
  <div class="pdfBG">
    <div v-for="i in numPages" :key="i">
      <!-- @progress="loadedRatio = $event" -->
        <pdf :src="src" :page="i" ></pdf>
    </div>
    <!-- 发送邮件 -->
    <section class="mail_box" v-if="parkLotId">
      <input type="text" v-model="email" placeholder="请填写可接收的邮箱地址" />
      <span @click="send">发送</span>
    </section>

     <section class="mail_box" v-if="meetingRoomId && isAgreement==1 ">
      <input type="text" v-model="email" placeholder="请填写可接收的邮箱地址" />
      <span @click="sendmeeting()">发送</span>
    </section>
     <section class="mail_box" v-if="invoiceId">
      <input type="text" v-model="email" placeholder="请填写可接收的邮箱地址" />
      <span @click="sendInvoice">发送</span>
    </section>
    
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import util from "../../utils/util";
import {loadParkHeaderById ,meetingSendAgreementEmail,sendInvoicePdfEmail } from '../../utils/api';

export default {
    name:'yuelanpdf',
    components:  {
       pdf
   },
  //  metaInfo: {
  //     meta: [
  //       { charset: 'utf-8' },
  //       { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes' }
  //     ]
  //   },
    data(){
      return {
        src:'',
        srcFlie:'',
        currentPage: 0, // pdf文件页码
        numPages:[],
        pageCount: 0, // pdf文件总页数
        loadedRatio: 0,
        come:'',
        parkLotId:'',//来自停车 车位id
        email:'',//邮件
        fileType: 'pdf', // 文件类型
        invoiceId:'',//来自发票
        meetingRoomId:'',
        isAgreement:'',
        agreementName:'',
        srcFlieZDinfo:'',

      }
    },
    created(){
      this.parkLotId = this.$route.query.parkLotId || '';
      let url = localStorage.getItem("src");
      this.src =url;
      let url1 = localStorage.getItem("srcFlie");
      this.srcFlie =url1
      util.showLoading();
      this.src = pdf.createLoadingTask(this.src);
      this.src.then(pdf => {
            util.hideLoading()
            this.numPages = pdf.numPages //获取总页数
        }).catch(() => {
      })
      this.meetingRoomId = this.$route.query.meetingRoomId ||'';
      this.isAgreement = this.$route.query.isAgreement||'';
      this.agreementName = this.$route.query.agreementName ||'';
      this.invoiceId = this.$route.query.invoiceId ||'';
      if(this.invoiceId){
         var str = localStorage.getItem("srcFlieZDinfo");
         this.srcFlieZDinfo = JSON.parse(str);
      }
     
    },
     methods: {
      // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
      changePdfPage (val) {
        // console.log(val)
        if (val === 0 && this.currentPage > 1) {
          this.currentPage--
        }
        if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
        }
      },
      downLoad(){
        window.location.href = this.src
      },
      // pdf加载时
      loadPdfHandler (e) {
        this.currentPage = 1 // 加载的时候先加载第一页
      },
      isEmail(str){
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            ///^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        return reg.test(str);
      },
      send(){
        console.log(this.email)
        if(!this.isEmail(this.email)){
          util.showToast("请填写正确的邮箱地址~");
          return false;
        }
        util.showLoading()
        let params = {
          id:this.$route.query.id,
          parkLotId:this.$route.query.parkLotId,
          email:this.email,
          url:"/parking/rstParkLot/sendContractEmail"
        }
        loadParkHeaderById(params).then(res=>{
          util.hideLoading()
          if(res.res && res.res.code === 10000){
            this.$router.replace(`/successPage?title=发送成功&desc=已成功发送至电子邮箱，请注意查收~`)
          }else{
            util.showToast(res.res.msg)
          }
        })
      },
      sendmeeting(){
         if(!this.isEmail(this.email)){
          util.showToast("请填写正确的邮箱地址~");
          return false;
        }
        console.log("in sendmeeting")
        util.showLoading()
        let params = {
          meetingRoomId:this.meetingRoomId,
          agreementName :this.agreementName ,
          email:this.email,
          path:this.srcFlie,
        }
        meetingSendAgreementEmail(params).then(res=>{
          util.hideLoading()
          if(res.res && res.res.code === 10000){
            this.$router.replace(`/successPage?title=发送成功&desc=已成功发送至电子邮箱，请注意查收~`)
          }else{
            util.showToast(res.res.msg)
          }
        })

      },
      sendInvoice(){
         if(!this.isEmail(this.email)){
          util.showToast("请填写正确的邮箱地址~");
          return false;
        }
        console.log("in sendmeeting")
        util.showLoading()
        let params = {
          purchaser: this.srcFlieZDinfo.purchaser,   //购方名称
          purchaserTaxpayerNumber: this.srcFlieZDinfo.purchaserTaxpayerNumber,  //购方税号
          invoiceNo:  this.srcFlieZDinfo.invoiceNo, //发票编号
          invoiceCode:  this.srcFlieZDinfo.invoiceCode, //发票代码
          invoiceTime:  this.srcFlieZDinfo.invoiceTime, //开票日期
          pdfUrl: this.srcFlieZDinfo.pdfUrl, //附件链接
          amountWithTax:this.srcFlieZDinfo.amountWithTax,//开票金额
          email:this.email,
          path:this.srcFlie,
        }
        sendInvoicePdfEmail(params).then(res=>{
          util.hideLoading()
          if(res.res && res.res.code === 10000){
            this.$router.replace(`/successPage?title=发送成功&desc=已成功发送至电子邮箱，请注意查收~`)
          }else{
            util.showToast(res.res.msg)
          }
        })

      },
    }
}
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.pdfBG{
    width: 100%;
    height: 100%;
    background-color: #f3f4f6;
  .downLoad{
    position:fixed;
    bottom:0;left:0;
    height:88px;
    right:0;
    text-align: center;
    line-height: 88px;
    background:@color17;
    color:#fff;
  }
}
.pdf{
    // width: 100%;
    // height: 100%;
}
.mail_box{
  position:fixed;
  bottom:0;left:0;right:0;
  height:120px;
  background:#fff;
  .flex();
  align-items:center;
  jusctify-content:space-between;
  padding:0 20px;
  input{
    flex:1;
    height:80px;
    border-radius:4px;
    border:2px solid rgba(234,234,234,1);
    font-size:32px;
    padding-left:20px;
  }
  span{
    width:200px;
    height:80px;
    background:rgba(23,64,218,1);
    border-radius:4px;
    margin-left:20px;
    color:#fff;
    font-size:32px;
    line-height:80px;
    text-align:center;
  }
}
</style>